import React from 'react';
import { Box, Button, Typography, Paper, Grid, Chip } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BarChartIcon from '@mui/icons-material/BarChart';
import { useNavigate } from 'react-router-dom';
import ContainerPainel from 'components/container_painel';

const HomeCicaaf: React.FC = () => {
  const navigate = useNavigate();


  return (
    <ContainerPainel pagina='CICAAF' showBackButton={true}>
      <Box
        sx={{
          paddingTop: 15,
          backgroundColor: '#f9fafb',
          minHeight: 'auto',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
          Secretaria de Estado de Agricultura Familiar
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          Cadastro de Informações da Cooperação e Associativismo para a Agricultura Familiar
        </Typography>

        <Grid container spacing={4} justifyContent="center" sx={{ mb: 4, maxWidth: 900, margin: '0 auto' }}>
          <Grid item xs={12} sm={6} md={6}>
            <Paper
              elevation={3}
              sx={{ padding: 4, textAlign: 'centers', borderRadius: '12px' }}
            >
              <AssignmentIcon fontSize="large" sx={{ mb: 1, color: '#0f172a' }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Operador Municipal
              </Typography>
              <Typography variant="body2" sx={{ mb: 2 }}>
                Preencha os formulários de coleta CICAAF
              </Typography>
              <Button
                variant="contained"
                fullWidth
                sx={{ backgroundColor: '#0f172a', '&:hover': { backgroundColor: '#1e293b' } }}
                onClick={() => navigate('/cicaaf/coleta')}
              >
                Iniciar Coleta
              </Button>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6} md={6}>
            <Paper
              elevation={3}
              sx={{ padding: 4, textAlign: 'center', borderRadius: '12px' }}
            >
              <BarChartIcon fontSize="large" sx={{ mb: 1, color: '#15803d' }} />
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Visualizar coletas
              </Typography>
              <Typography variant="body2" sx={{ mb: 2 }}>
                Visualize suas coletas do município
              </Typography>
              <Button
                variant="contained"
                fullWidth
                sx={{ backgroundColor: '#22c55e', '&:hover': { backgroundColor: '#16a34a' } }}
                onClick={() => navigate('/cicaaf/gerenciamento-coletas')}
              >
                LISTAGEM DE REGISTROS
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </ContainerPainel >
  );
};

export default HomeCicaaf;
